// extracted by mini-css-extract-plugin
module.exports = {"content":"Edit_content__1BjCl"};